<template>
    <div class="body-panel dataContent">
        <template v-if="news != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back margin-right-10">
                            <a class="router-link-active" href="" @click.prevent="back">Назад</a>
                        </p>
                        <p class="caption-help margin-right-10" v-if="news.new">Добавление новости</p>
                        <p class="caption-help" v-if="!news.new">Редактирование новости #{{ news.Id }}</p>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex">
                        <button type="button" class="btn btn-primary" @click="saveNews()" :disabled="savingInProgress">Сохранить</button>
                        <button type="button" class="btn btn-delete" @click="deleteNews">Удалить</button>
                    </div>
                </div>
            </div>
            <div class="body-panel-content body-panel-content-page">
                <div class="body-panel">
                    <form action="/news" class="form-horizontal" novalidate="novalidate" ref="myForm" method="post" enctype="multipart/form-data">
                        <input type="hidden" :value="news.Id" name="Id" />
                        <div class="block-in-page">
                            <div class="form-field">
                                <label class="input-text-lbl">
                                    Заголовок новости
                                    <span class="required" aria-required="true">*</span>
                                </label>
                                <input name="Title" :class="['input-text', {'input-error': errors.has('Title')}]" type="text" v-validate="'required'" v-model="news.Title">
                                <span class="field-validation-valid">{{ errors.first('Title') }}</span>
                            </div>
                            <div class="form-field-group margin-top-10">
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Начало публикации
                                        <span class="required" aria-required="true">*</span>
                                    </label>
                                    <div class="input-date-lbl">
                                        <input-date name="StartDateFormatted"
                                                    v-validate="'required'"
                                                    v-model="news.StartDateFormatted"
                                                    :class="[{'input-error': errors.has('StartDateFormatted')}]"></input-date>
                                        <span class="field-validation-valid">{{ errors.first('StartDateFormatted') }}</span>
                                    </div>
                                    <span class="field-validation-valid"></span>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Окончание публикации
                                        <span class="required" aria-required="true"></span>
                                    </label>
                                    <div class="input-date-lbl">
                                        <input-date name="EndDateFormatted" v-model="news.EndDateFormatted"></input-date>
                                    </div>
                                    <span class="field-validation-valid">{{ errors.first('EndDateFormatted') }}</span>
                                </div>
                                <div class="form-field">
                                    <input id="Pinned" name="Pinned" value="true" type="checkbox" class="input-checkbox" v-model="news.Pinned" />
                                    <label for="Pinned" class="input-checkbox-lbl">Закрепить первым</label>
                                </div>
                            </div>
                            <div class="margin-top-10">
                                <div class="form-group">
                                    <label class="input-text-lbl">
                                        Превью новости
                                        <span class="required" aria-required="true">*</span>
                                    </label>
                                    <textarea name="Preview" :class="['input-memo', {'input-error': errors.has('Preview')}]" rows="10" style="height:100px" v-validate="'required'" v-model="news.Preview"></textarea>
                                    <span class="field-validation-valid">{{ errors.first('Preview') }}</span>
                                </div>
                            </div>
                            <div class="margin-top-10">
                                <div class="form-group">
                                    <label class="input-text-lbl">
                                        Текст новости
                                        <span class="required" aria-required="true">*</span>
                                    </label>
                                    <textarea name="Body" :class="['input-memo', {'input-error': errors.has('Body')}]" rows="10" style="height:250px" v-validate="'required'" v-model="news.Body"></textarea>
                                    <span class="field-validation-valid">{{ errors.first('Body') }}</span>
                                </div>
                            </div>
                            <div class="form-field margin-top-10">
                                <input id="LikesEnabled" name="LikesEnabled" value="true" type="checkbox" class="input-checkbox" v-model="news.LikesEnabled" />
                                <label for="LikesEnabled" class="input-checkbox-lbl">Разрешить ставить лайки</label>
                            </div>
                            <div class="form-field">
                                <input id="CommentsEnabled" name="CommentsEnabled" value="true" type="checkbox" class="input-checkbox" v-model="news.CommentsEnabled" />
                                <label for="CommentsEnabled" class="input-checkbox-lbl">Разрешить комментирование</label>
                            </div>
                            <div class="form-field">
                                <input id="DisplayViews" name="DisplayViews" value="true" type="checkbox" class="input-checkbox" v-model="news.DisplayViews" />
                                <label for="DisplayViews" class="input-checkbox-lbl">Отображать просмотры</label>
                            </div>
                        </div>

                        <div class="block-in-page">
                            <div class="flex">
                                <image-setting :img="imgSite" :name="'site'" :parentImage="true" @onImageViewChanged="onImageViewChanged"></image-setting>
                                <div class="form-field" style="width:300px;min-width:300px;margin-left:20px">
                                    <div class="panel-block panel-block-new" style="margin-right:0">
                                        <div class="panel-block-img-base">
                                            <div class="panel-block-img">
                                                <img :src="imgSitePath" alt="" :style="imageStyleFormatted" v-if="imgSitePath" />
                                            </div>
                                        </div>
                                        <div class="panel-block-info">
                                            <p class="panel-block-header margin-bottom-10">{{ news.Title }}</p>
                                            <p class="panel-body-desc" v-html="news.PreviewFormatted"></p>
                                        </div>
                                        <div class="panel-body-actions">
                                            <button type="button" class="btn" @click="">Читать</button>
                                            <span class="panel-body-actions-date">{{ news.StartDate | date-short }}</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="block-in-page">
                            <div class="flex">
                                <image-setting :img="imgMobile" :parentImgPath="imgSitePath" :name="'mobile'" @onImageViewChanged="onImageViewChanged"></image-setting>
                                <div class="form-field" style="width:500px;min-width:500px;margin-left:20px">
                                    <div class="panel-block panel-block-new panel-block-mobile" style="margin-right:0">
                                        <div class="flex">
                                            <div class="panel-block-img-base panel-block-img-mobile">
                                                <div class="panel-block-img panel-block-img-mobile">
                                                    <img :src="imgMobilePath" alt="" :style="imageStyleMobileFormatted" v-if="imgMobilePath" />
                                                </div>
                                            </div>
                                            <div class="panel-block-info">
                                                <p class="panel-block-header margin-bottom-10">{{ news.Title }}</p>
                                                <p class="panel-body-desc" v-html="news.PreviewFormatted"></p>
                                            </div>
                                        </div>
                                        <div class="panel-body-actions">
                                            <button type="button" class="btn" @click="">Читать</button>
                                            <span class="panel-body-actions-date">{{ news.StartDate | date-short }}</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </template>

        <vue-headful title="Новости" />
    </div>
</template>

<script>
    let $ = require('jquery');
    window.$ = $;
    window.jQuery = $;

    import BackendApi from '../../backendApi'
    import UI from '../../helpers/ui-helpers'
    import moment from 'moment'
    import config from '../../config'

    let backendApi = new BackendApi();

    let ImageStyleDefault = {
        top: 0,
        left: 100,
        translateY: 0,
        translateX: -50,
        size: 100,
        resizeType: 1
    };

    let loadFroalaScripts = function(callback){
        let present = false;
        let scriptSrc = '/Content/custom/Froala/htmleditor.min.js';
        let scripts = document.getElementsByTagName('script');
        for (let i = scripts.length; i--;) {
            if (scripts[i].src === scriptSrc){
                present = true;
                break;
            }
        }

        if(!present){
            let link1 = document.createElement('link');
            link1.setAttribute('rel', 'stylesheet');
            link1.setAttribute('type', 'text/css');
            link1.href = '/Content/custom/Froala/htmleditor.min.css';
            document.head.appendChild(link1);

            let link2 = document.createElement('link');
            link2.href = '/Content/custom/FontAwesome/css/font-awesome.css';
            link2.setAttribute('rel', 'stylesheet');
            link2.setAttribute('type', 'text/css');
            document.head.appendChild(link2);

            let script = document.createElement('script');
            script.onload = function () {
                callback();
            };
            script.src = scriptSrc;
            document.head.appendChild(script);
        }else{
            callback();
        }
    };

    export default {
        name: "news-edit",
        data() {
            return {
                news: null,
                file: null,
                deleteImage: false,
                imgMobilePath: null,
                imgMobile: {},
                imgSitePath: null,
                imgSite: {},
                savingInProgress: false
            }
        },

        computed: {
            imageStyleFormatted() {
                let settings = {
                    left: this.news.ImageStyle.left + '%',
                    top: this.news.ImageStyle.top + '%',
                    transform: 'translateY(' + this.news.ImageStyle.translateY + '%) translateX(' +
                    this.news.ImageStyle.translateX + '%)'
                };
                if (this.news.ImageStyle.resizeType === 1 && parseInt(this.news.ImageStyle.size)) {
                    settings.height = this.news.ImageStyle.size + '%';
                }
                if (this.news.ImageStyle.resizeType === 2 && parseInt(this.news.ImageStyle.size)) {
                    settings.width = this.news.ImageStyle.size + '%';
                }

                return settings;
            },
            imageStyleMobileFormatted() {
                let settings = {
                    left: this.imgMobile.ImageStyle.left + '%',
                    top: this.imgMobile.ImageStyle.top + '%',
                    transform: 'translateY(' + this.imgMobile.ImageStyle.translateY + '%) translateX(' +
                        this.imgMobile.ImageStyle.translateX + '%)'
                };
                if (this.imgMobile.ImageStyle.resizeType === 1 && parseInt(this.imgMobile.ImageStyle.size)) {
                    settings.height = this.imgMobile.ImageStyle.size + '%';
                }
                if (this.imgMobile.ImageStyle.resizeType === 2 && parseInt(this.imgMobile.ImageStyle.size)) {
                    settings.width = this.imgMobile.ImageStyle.size + '%';
                }

                return settings;
            },
        },

        watch: {
            'news.Preview': function () {
                this.news.PreviewFormatted = this.news.Preview ? this.news.Preview.replace(/\n/g, '<br>') : null;
            }
        },

        methods: {
            back() {
                this.$router.back();
            },

            loadNews() {
                let that = this;
                let id = parseInt(this.$route.params.id);
                if (id === 0) {
                    this.news = {
                        Id: 0,
                        new: true,
                        ImageStyle: JSON.parse(JSON.stringify(ImageStyleDefault)),
                        ImageStyleMobile: JSON.parse(JSON.stringify(ImageStyleDefault)),
                        ImageMobile: {}
                    };
                    that.imgSite = {
                        ImageStyle: that.news.ImageStyle,
                        ImagePath: null,
                        Image: {}
                    };
                    that.imgMobile = {
                        ImageStyle: that.news.ImageStyleMobile,
                        ImagePath: null,
                        Image: {}
                    };

                    return new Promise(resolve => resolve());
                }
                else {
                    return backendApi.newsLoad(id).then(function (response) {
                        //console.info('project.edit -> load, response:', response.data);
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при загрузке новости');
                        }
                        else {
                            if (response.data == null) {
                                that.$router.back();
                            }

                            if (response.data.ImageStyle) {
                                response.data.ImageStyle = JSON.parse(response.data.ImageStyle);
                            } else {
                                response.data.ImageStyle = JSON.parse(JSON.stringify(ImageStyleDefault));
                            }
                            if (response.data.ImageStyleMobile) {
                                response.data.ImageStyleMobile = JSON.parse(response.data.ImageStyleMobile);
                            } else {
                                response.data.ImageStyleMobile = JSON.parse(JSON.stringify(ImageStyleDefault));
                            }

                            that.news = Object.assign(response.data, {FileData: null});
                            that.news.StartDateFormatted = moment(that.news.StartDate).format('DD.MM.YYYY');
                            if(that.news.EndDate) {
                                that.news.EndDateFormatted = moment(that.news.EndDate).format('DD.MM.YYYY');
                            }
                            that.news.ImageMobile = {};

                            that.imgMobile = {
                                ImageStyle: that.news.ImageStyleMobile,
                                ImagePath: that.news.ImageMobilePath,
                                Image: {}
                            };
                            that.imgSite = {
                                ImageStyle: that.news.ImageStyle,
                                ImagePath: that.news.Image,
                                Image: {}
                            };
                        }
                    })
                }
            },

            saveNews() {
                let vm = this;

                this.$validator.validate().then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else {
                        if (vm.savingInProgress) {
                            return;
                        }
                        vm.savingInProgress = true;
                        UI.blockUI('.dataContent', 'Сохранение...');

                        let selectedProjectId = localStorage.getItem('selectedProjectId');

                        let saveObj = Object.assign({}, vm.news, {
                            StartDate: moment(vm.news.StartDateFormatted, 'DD.MM.YYYY').format(),
                            EndDate: moment(vm.news.EndDateFormatted, 'DD.MM.YYYY').format(),
                            DeleteImage: vm.imgSite.Image.Id === -1,//vm.deleteImage,
                            ProjectId: selectedProjectId != null ? parseInt(selectedProjectId) : null,
                            Body: $('[name="Body"]').froalaEditor('html.get', true)
                        });
                        saveObj.ImageStyle = JSON.stringify(vm.imgSite.ImageStyle);
                        saveObj.FileData = vm.imgSite.Image.FileData;
                        saveObj.FileName = vm.imgSite.Image.FileName;
                        saveObj.ImageMobile = vm.imgMobile.Image;
                        if (vm.imgMobile.ImageStyle.useMainPhoto) {
                            saveObj.ImageMobile.FileName = '';
                            saveObj.ImageMobile.FileData = '';
                            saveObj.ImageMobile.Id = -1;
                            saveObj.ImageMobilePath = '';
                        }
                        saveObj.ImageStyleMobile = JSON.stringify(vm.imgMobile.ImageStyle);

                        backendApi.newsSave(saveObj).then(function (response) {
                            UI.unblockUI('.dataContent');
                            if (response.hasError) {
                                UI.toastr.error('Ошибка при сохранении новости');
                            } else {
                                UI.toastr.success('Успешно сохранено');
                                vm.$router.push('/news/' + response.data);
                            }
                            vm.savingInProgress = false;
                        });
                    }
                });
            },

            deleteNews(){
                let that = this;

                if (confirm('Вы уверены?')) {
                    UI.blockUI('.portlet', 'Удаление...');
                    backendApi.newsDelete(that.news.Id).then(function (response) {
                        UI.unblockUI('.portlet');
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при удалении новости');
                        } else {
                            UI.toastr.success('Успешно удалено');
                            that.$router.push('/news');
                        }
                    });
                }
            },

            onImageViewChanged(imgPath, name) {
                if (name === 'site')
                    this.imgSitePath = imgPath;
                else
                    this.imgMobilePath = imgPath;
            }
        },

        mounted() {
            let vm = this;

            UI.blockUI('.dataContent', 'Загрузка...');
            this.loadNews().then(() => {
                UI.unblockUI('.dataContent');

                loadFroalaScripts(function () {
                    $('[name="Body"]').froalaEditor({
                        language: 'ru',
                        toolbarButtons: [
                            'undo', 'redo', '|', 'bold', 'italic', 'underline', '|',
                            'fontSize', 'color', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '|',
                            'insertLink', 'insertImage', 'insertVideo', 'insertTable', 'insertHR'],
                        charCounterCount: false,
                        //imageEditButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
                        imageSplitHTML: true,
                        imageUploadURL: config.apiUrl + '/api/news/uploadFiles?fileType=NewsImages&newsId=' + (vm.news.Id || 0),
                        imageUploadMethod: 'POST',
                        imageMaxSize: 5 * 1024 * 1024,
                        imageAllowedTypes: ['jpeg', 'jpg', 'png'],

                        videoUpload: false,
                        useClasses: false
                    }).on('froalaEditor.contentChanged', function (e, editor) {
                      vm.news.Body = $('[name="Body"]').froalaEditor('html.get', true);
                    });
                });

            });

        },

        destroyed(){
            //$(document).off('change', '[name="dropFiles"]');
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// Content/src/views/edit/NewsEdit.vue